import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import useCSRFToken from 'hooks/use-csrf-token';

import type { FreelancerAvailableTime, Response } from '../types';

import client from '../client';

type UseUpdateFreelancerAvailableTimeInput = {
  data: {
    days: Array<FreelancerAvailableTime>;
    repeat: boolean;
    // eslint-disable-next-line camelcase
    repeat_end?: string;
  };
  date: string;
};

const useUpdateFreelancerAvailableTime = (): UseMutationResult<
  Response,
  string,
  UseUpdateFreelancerAvailableTimeInput,
  unknown
> => {
  const csrfToken = useCSRFToken();
  const mutation = useMutation<
    Response,
    string,
    UseUpdateFreelancerAvailableTimeInput
  >(
    ['use-update-freelancer-available-time'],
    async (params: UseUpdateFreelancerAvailableTimeInput) => {
      const response = await fetch(`/api/available_days/week/${params.date}/`, {
        body: JSON.stringify(params.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        method: 'POST',
      });
      if (response.ok) return response.json();
      throw new Error('Something went wrong');
    },
    {
      onSuccess: () => {
        const queriesToInvalidate = ['get-freelancer-available-time'];
        queriesToInvalidate.forEach((query) => {
          client.invalidateQueries(query);
        });
      },
    },
  );
  return mutation;
};

export default useUpdateFreelancerAvailableTime;
